<template>
  <div class="leftTop">
    <div class="title">
      <img class="titleIcon"
           src="@/assets/image/jieshao.png" />
      <div class="titleMian">一桥一档</div>
    </div>
    <div class="main">
      <div class="mainText">
        桥梁简介：{{bridgeObj.introduce?bridgeObj.introduce:"暂无介绍"}}
      </div>
      <!-- <div class="mainText">
        下部构造：桥墩采用灌注柱基础重力式墩，墩基础埋置于基岩，桥台为灌注桩基础组合式桥台，台基础置于密实胶结砂卵石层。
      </div> -->
      <div class="qiaoLiangTuzhi">
        <el-image :src="bridgeObj.bridgePicture"
                  :preview-src-list="[bridgeObj.bridgePicture]">
        </el-image>
      </div>
      <!-- 
桥墩采用灌注柱基础重力式墩，墩基础埋置于基岩，桥台为灌注桩基础组合式桥台，台基础置于密实胶结砂卵石层。 -->
      <!-- <div class="mainText">
        桥梁简介：三孔43m，矢跨比1/10刚架拱。桥面沥青混凝土铺装，异型钢伸缩缝等。
      </div>
      <div class="mainText">
        设计荷载：汽车-20，挂车-100。
      </div>
      <div class="mainText">
        桥面全宽：26.2m。
      </div>
      <div class="mainText">
        上部结构：三孔43m，矢跨比1/10刚架拱。桥面沥青混凝土铺装，异型钢伸缩缝等。
      </div>
      <div class="mainText">
        下部构造：桥墩采用灌注柱基础重力式墩，墩基础埋置于基岩，桥台为灌注桩基础组合式桥台，台基础置于密实胶结砂卵石层。
      </div> -->

    </div>
  </div>
</template>

<script>
export default {
  name: "leftBottom",
  data () {
    return {
      tableImg: require('../../../assets/image/table.png')
    };
  },
  props: {
    bridgeObj: {
      type: Object,
      default: {},
    },
  },
  watch: {
    bridgeObj: {
      deep: true,
      handler () {
        this.bridgeObj.urlList = this.bridgeObj.bridgePictureUrl?this.bridgeObj.bridgePictureUrl.split(","):[];
      },
    },
  },
  components: {},
  methods: {},
  computed: {},

  created () { },
  mounted () { },
  beforeDestroy () { },
  destroyed () { },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.leftTop {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 30px;
    .titleIcon {
      width: 20px;
      height: 20px;
    }
    .titleMian {
      margin-left: 10px;
      color: #ffffff;
      line-height: 30px;
      font-size: 18px;
    }
  }
  .main {
    height: calc(100% - 45px);
    margin-top: 15px;
    overflow: overlay;
    color: #ffffff;
    line-height: 20px;
    font-size: 16px;
    .mainText {
      text-align: left;
      margin-bottom: 10px;
    }
    .mainText2 {
      margin: 20px 0;
      text-align: left;
    }
    .qiaoLiangTuzhi {
      margin: 0 auto;
      width: 200px;
      // height: 350px;
      position: relative;
      .fangDa {
        width: 20px;
        height: 20px;
        background: url("../../../assets/image/dangDa.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 10px;
        bottom: 10px;
        z-index: 99;
      }
    }
  }
}
::v-deep .el-carousel__container {
  height: 210px;
  width: 100%;
}
::v-deep .el-image {
  width: 100%;
  height: 100%;
}
</style>